import { createContext, useContext } from "react"

export const MIXED = "Mixed"

const MixedValuesContext = createContext<ReadonlySet<string>>(new Set())

/** The fields, by name, where the selected objects differ: they show "Mixed". */
export const MixedValuesProvider = MixedValuesContext.Provider

export const useIsMixed = (name: string) => useContext(MixedValuesContext).has(name)
